import axios from "axios";
import { BrandingApiResponse } from "./types";

const BRANDING_REQUEST_TIMEOUT_MS = 8000;

const getBrandName = async (url: string): Promise<string> => {
  const safeUrl = new URL(url);
  const res = await axios.get<BrandingApiResponse>(
    `/api/v2/branding?Url=${encodeURIComponent(safeUrl.toString())}`,
    { timeout: BRANDING_REQUEST_TIMEOUT_MS },
  );
  return res.data.brandingName;
};

export default { getBrandName };
